import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

interface DataSourceFilterProps {
    selectedSources: string[];
    onSourceChange: (sources: string[]) => void;
}

const DataSourceFilter: React.FC<DataSourceFilterProps> = ({
    selectedSources,
    onSourceChange,
}) => {
    const { isDark } = useTheme();

    const dataSources = [
        { 
            id: 'whoop', 
            label: 'WHOOP',
            logo: '/logos/whoop-logo.png'
        },
        { 
            id: 'garmin', 
            label: 'GARMIN',
            logo: '/logos/garmin/garmin-logo.png'
        },
    ];

    const toggleSource = (sourceId: string) => {
        if (selectedSources.includes(sourceId)) {
            // Don't allow deselecting if it's the only one selected
            if (selectedSources.length > 1) {
                onSourceChange(selectedSources.filter((s) => s !== sourceId));
            }
        } else {
            onSourceChange([...selectedSources, sourceId]);
        }
    };

    return (
        <div className="mb-8 transition-all duration-300">
            {/* Full-width container matching TabNavigation styling */}
            <div className="cgm-card rounded-2xl p-2 px-4">
                <div className="flex flex-col sm:flex-row sm:items-center w-full gap-3 sm:gap-0">
                    {/* Title section */}
                    <div className="flex-shrink-0 sm:mr-6">
                        <h3 className="text-base font-semibold cgm-text-primary">Data Source</h3>
                        <p className="text-xs cgm-text-secondary">Filter dashboard by wearable device</p>
                    </div>

                    {/* Buttons - taking remaining space */}
                    <div className="flex space-x-2 sm:space-x-4">
                        {dataSources.map((source) => {
                            const isSelected = selectedSources.includes(source.id);
                            return (
                                <button
                                    key={source.id}
                                    onClick={() => toggleSource(source.id)}
                                    className={`cgm-tab flex items-center justify-center px-4 py-2 sm:px-8 sm:py-3 rounded-xl transition-all duration-200 min-w-[100px] sm:min-w-[140px]
                                        ${isSelected ? 'cgm-tab-active' : ''}`}
                                    title={`Toggle ${source.label} data`}
                                >
                                    <img
                                        src={source.logo}
                                        alt={`${source.label} logo`}
                                        className="h-4 sm:h-5 w-auto"
                                        style={{
                                            filter: isSelected 
                                                ? (isDark ? 'brightness(0) invert(1)' : 'none')
                                                : (isDark ? 'brightness(0) invert(0.5)' : 'brightness(0) invert(0.5)'),
                                            opacity: isSelected ? 1 : 0.6
                                        }}
                                    />
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DataSourceFilter;
